  <form id="mainAppointerForm" [formGroup]="appointerForm" (ngSubmit)="onSubmit()">
    <div class="mange-carriers-container edit-appointer d-flex align-items-center gap-1" *ngIf="!isPopupView">
      <div class="manage-carriers-detail d-flex align-items-center gap-1">
        <div class="back-btn">
          <a href="javascript:void();" (click)="targetLink('edit-carrier')">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
              <g id="btn_back" transform="translate(-315 -129)">
                <rect id="Rectangle_18055" data-name="Rectangle 18055" width="24" height="24"
                      transform="translate(315 129)" fill="none" />
                <path id="arrow_back_FILL0_wght300_GRAD0_opsz24"
                      d="M11.1,19.1,4.65,12.625a.7.7,0,0,1-.212-.288.936.936,0,0,1,0-.675.7.7,0,0,1,.212-.287L11.1,4.9a.822.822,0,0,1,.525-.213.678.678,0,0,1,.525.213.765.765,0,0,1,.237.525.753.753,0,0,1-.212.55l-5.3,5.275H18.5a.741.741,0,0,1,.525.212.755.755,0,0,1,0,1.075.74.74,0,0,1-.525.213H6.875l5.3,5.3a.736.736,0,0,1,.212.512.691.691,0,0,1-.212.538.755.755,0,0,1-1.075,0Z"
                      transform="translate(315.188 128.994)" fill="#9e9e9e" />
              </g>
            </svg>
          </a>
        </div>
        <div class="user-details pl-2">
          <div class="block-title">
            <h1 class="d-flex align-items-center gap-1" *ngIf="isEdit == 'edit-appointer'">
              <span>{{appointerData?.firstName}} {{appointerData?.lastName}}</span>
               <span class="tag-default ml-2 bold-500" style="line-height: 14px;">{{appointerData?.appointmentState}} | {{appointerData?.licenseNumber}}</span>
                <!-- <span class="tag ml-2">{{appointerData.appointmentState}} | {{appointerData.licenseNumber}}</span> -->
              </h1>
            <h1 *ngIf="isEdit == 'add-appointer' || isEdit == 'copy-appointer'">Add  Appointer Information</h1>
          </div>
          <!-- <div class="block-desc" *ngIf="isEdit == 'edit-appointer'">
            <p>Created date: {{appointerData?.createdDate | date:'MM/dd/yyyy hh:mm a' }}</p>
          </div> -->
        </div>
      </div>
      <div class="new-group-block d-flex align-items-center gap-1">
        <span *ngIf="isEdit == 'edit-appointer'" class="description-light">Last updated by: 
          <span class="title-6">{{ appointerData?.updatedByUser? appointerData?.updatedByUser: appointerData?.createdByUser}}</span> on 
          <span class="title-6" *ngIf="appointerData?.updatedDate == null">{{ appointerData?.createdDate | date:'MM/dd/yyyy hh:mm a'}}</span>
          <span class="title-6" *ngIf="appointerData?.updatedDate">{{ appointerData?.updatedDate | date:'MM/dd/yyyy hh:mm a'}}</span>
        </span>
        <button type="button" class="btn btn-cancel" (click)="openConfirmationPopup()" [disabled]="appointerForm.pristine">
          Cancel
        </button>
        <button class="btn save-btn" type="submit" [disabled]="!appointerForm.valid || appointerForm?.value?.complianceOfficer?.length <= 0">
          Save
        </button>
      </div>
    </div>
    <div class="add-appointer-detail carrier-appointer" [class.pageView]="!isPopupView" [class.scroll-add-appointer]="isPopupView">
      <div class="container-fluid" [class.px-4]="isPopupView">
       
        <div class="block-title form-grouping-title">
          <h2>Resident License Information</h2>
          <div class="horizontal-line"></div>
        </div>
        <div class="row">
          <div class="col-4">
            <div class="add-user-detail">
              <label for="">Resident state code<span class="validation-field">*</span></label>
              <!-- <input type="text" class="form-control" maxlength="2" (keypress)="sharedService.alphaOnly($event)" formControlName="appointerResidenceStateCode" placeholder="Res state code"> -->
              <div class="input-block">
                <ng-select class="form-control w-100" formControlName="appointerResidenceStateCode" tabindex="0" [items]="masterStates" bindLabel="stateNameWithStateCode" bindValue="stateCode" [searchable]="true" [clearable]="true" placeholder="State code">
                  <ng-option *ngFor="let state of masterStates" [value]="state.stateCode">{{state.stateNameWithStateCode}}</ng-option>
                </ng-select>
              </div>
            </div>
          </div>
          <div class="col-4  pd-l-0">
            <div class="add-user-detail">
              <label for="">Resident state license number<span class="validation-field">*</span></label>
              <input type="text" class="form-control" [maxLength]="25" formControlName="appointerResidenceStateLicenseId" placeholder="Res state license number">
            </div>
          </div>
          <div class="col-4 pd-l-0">
            <div class="add-user-detail">
              <label for="">Resident state company code<span class="validation-field">*</span></label>
              <input type="text" class="form-control" [maxLength]="15" formControlName="appointerResidenceStateCompanyId" placeholder="Resident state company code">
            </div>
          </div>
        </div>

        <div class="block-title form-grouping-title pt-2">
          <h2>State License Information</h2>
          <div class="horizontal-line"></div>
        </div>
        <div class="row">
          <div class="col-4">
            <div class="add-user-detail">
              <label for="">Appointment req. state<span class="validation-field">*</span></label>
              <div class="input-block">
                <ng-select class="form-control w-100" formControlName="stateId" tabindex="0" [readonly]="isPopupView || isEdit == 'edit-appointer'" (change)="getAppointerInfo()" [items]="appointerStates" bindLabel="stateNameWithStateCode" bindValue="stateId" [searchable]="true" [clearable]="true" placeholder="State code">
                  <ng-option *ngFor="let state of appointerStates" [value]="state.stateId">{{state.stateNameWithStateCode}}</ng-option>
                </ng-select>
              </div>
            </div>
          </div>
          <div class="col-8">
            <div class="row">
          <div class="col-4  pd-l-0">
            <div class="add-user-detail">
              <label for="">State company code<span class="validation-field">*</span></label>
              <input type="text" class="form-control" [readonly]="selectedAppointmentWith?.stateCompanyId || appointerData?.stateCompanyId" [maxLength]="15" formControlName="stateCompanyId" placeholder="State company code">
            </div>
          </div>
          <div class="col-4  pd-l-0">
            <div class="add-user-detail">
              <label for="">License number<span class="validation-field">*</span></label>
              <input type="text" class="form-control" readonly [maxLength]="25" formControlName="licenseNumber" placeholder="License number">
            </div>
          </div>
          <div class="col-4 pd-l-0">
            <div class="add-user-detail">
              <label for="">Resident type<span class="validation-field">*</span></label>
              <div class="input-block">
                <ng-select class="form-control w-100" [readonly]="true" formControlName="residenceTypeId" tabindex="0" [searchable]="true" [clearable]="true" placeholder="Resident type">
                  <ng-option [value]="1">Resident</ng-option>
                  <ng-option [value]="2">Non-Resident</ng-option>
                </ng-select>
              </div>
            </div>
          </div>
       </div>
       </div>
          
          <div class="col-12">
            <div class="add-user-detail">
              <label for="">Business address<span class="validation-field">*</span></label>
              <input type="text" class="form-control" [maxLength]="50" formControlName="addressLine1" placeholder="Address line 1">
            </div>
          </div>
          <div class="col-12 ">
            <div class="add-user-detail">
              <input type="text" class="form-control" [maxLength]="50" formControlName="addressLine2" placeholder="Address line 2">
            </div>
          </div>
          <div class="col-6">
            <div class="add-user-detail">
              <label for="">City<span class="validation-field">*</span></label>
              <input type="text" class="form-control" [maxLength]="35" formControlName="city" placeholder="City">
            </div>
          </div>
          <div class="col-3 pd-l-0">
            <div class="add-user-detail">
              <label for="">State code<span class="validation-field">*</span></label>
              <div class="input-block">
                <ng-select class="form-control w-100" formControlName="stateCode" tabindex="0" [items]="masterStates" bindLabel="stateCode" bindValue="stateCode" [searchable]="true" [clearable]="true" placeholder="State code">
                  <ng-option *ngFor="let state of masterStates" [value]="state.stateId">{{state.stateCode}}</ng-option>
                </ng-select>
              </div>
            </div>
          </div>
          <div class="col-3 pd-l-0">
            <div class="add-user-detail">
              <label for="">ZIP code<span class="validation-field">*</span></label>
              <input type="text" class="form-control" minlength="5" maxlength="10" (input)="formatZipCode($event)" formControlName="zip" placeholder="ZIP code">
            </div>
          </div>
        </div>
        
        <div class="block-title form-grouping-title pt-2">
          <h2>Personal Info</h2>
          <div class="horizontal-line"></div>
        </div>
        <div class="row">
          <div class="col-4">
            <div class="add-user-detail">
              <label for="">First name<span class="validation-field">*</span></label>
              <input type="text" class="form-control" [maxLength]="25" formControlName="firstName" placeholder="First name">
            </div>
          </div>
          <div class="col-4 pd-l-0">
            <div class="add-user-detail">
              <label for="">Last name<span class="validation-field">*</span></label>
              <input type="text" class="form-control" [maxLength]="100" formControlName="lastName" placeholder="Last name">
            </div>
          </div>
          <div class="col-4 pd-l-0">
            <div class="add-user-detail">
              <label for="">Title<span class="validation-field">*</span></label>
              <!--<div class="input-block">
                  <ng-select class="form-control" tabindex="0" formControlName="appointerTitle"
                      [searchable]="true" [clearable]="true" placeholder="Title">
                      <ng-option value="Mr">Mr</ng-option>
                      <ng-option value="Mrs">Mrs</ng-option>
                      <ng-option value="Miss">Miss</ng-option>
                  </ng-select>
              </div>-->
              <input type="text" class="form-control" [maxLength]="25" formControlName="appointerTitle" placeholder="Appointer title">
            </div>
          </div>
          <!-- <div class="col-2 pd-0 pd-r-16">
            <div class="add-user-detail">
              <label for="">Phone code<span class="validation-field">*</span></label>
              <div class="input-block">
                <ng-select class="form-control" formControlName="phoneCode" tabindex="0" [items]="contactCodeData" bindLabel="codeText" bindValue="codeValue" [searchable]="false" [clearable]="false" placeholder="Phone code">
                  <ng-option *ngFor="let code of contactCodeData" [value]="code.codeValue">{{code.codeText}}</ng-option>
                </ng-select>
              </div>
            </div>
          </div> -->
          <div class="col-4">
            <div class="add-user-detail">
              <label for="">Business phone number<span class="validation-field">*</span></label>
              <input type="text" class="form-control" formControlName="phoneNumber" [textMask]="{mask: mask}" placeholder="xxx-xxx-xxxx">
            </div>
          </div>

          <!-- <div class="col-2 pd-0 pd-r-16">
            <div class="add-user-detail">
              <label for="">Email code<span class="validation-field">*</span></label>
              <div class="input-block">
                <ng-select class="form-control" formControlName="emailCode" tabindex="0" [items]="contactCodeData" bindLabel="codeText" bindValue="codeValue" [searchable]="false" [clearable]="false" placeholder="Email code">
                  <ng-option *ngFor="let code of contactCodeData" [value]="code.codeValue">{{code.codeText}}</ng-option>
                </ng-select>
              </div>
            </div>
          </div> -->
          <div class="col-8 pd-l-0">
            <div class="add-user-detail">
              <label for="">Business email id<span class="validation-field">*</span></label>
              <input type="text" class="form-control" [maxLength]="50" formControlName="emailAddress" placeholder="Email address">
            </div>
          </div>
           <div class="col-6">
            <div class="add-user-detail">
              <label for="" class="input-name">I am authorized to submit this application<span class="validation-field">*</span></label>
              <div class="personal-info">
                <!-- <label class="radio-button-container">
                  <input type="radio" tabindex="0" formControlName="preparerCode" name="preparerCode" value="P">Producer
                  <span class="checkmark"></span>
                </label> -->
                <label class="radio-button-container radio-as-checkbox bold-400">
                  <input type="radio" tabindex="0" formControlName="preparerCode" name="preparerCode" value="S">Yes
                  <span class="checkmark"></span>
                </label>
              </div>
            </div>
          </div>
          <div class="col-6 pd-l-0">
            <div class="add-user-detail">
              <label for="" class="input-name">Are you a compliance officer?<span class="validation-field">*</span></label>
              <div class="personal-info">
                <label class="radio-button-container bold-400">
                  <input type="radio" tabindex="0" formControlName="complianceOfficer" name="complianceOfficer" value="Y">Yes
                  <span class="checkmark"></span>
                </label>
                <label class="radio-button-container bold-400">
                  <input type="radio" tabindex="0" formControlName="complianceOfficer" name="complianceOfficer" value="N">No
                  <span class="checkmark"></span>
                </label>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="add-user-detail">
              <label for="">The name of the firm authorizing or submitting the application on behalf of the applicant.</label>
              <input type="text" class="form-control" [maxLength]="100" formControlName="authFirmName" placeholder="Authorizing firm name">
            </div>
          </div>

          <!-- <div class="col-3 pd-0">
            <div class="add-user-detail">
              <label for="">Address code<span class="validation-field">*</span></label>
              <div class="input-block">
                <ng-select class="form-control" formControlName="addressCode" tabindex="0" [items]="contactCodeData" bindLabel="codeText" bindValue="codeValue" [searchable]="false" [clearable]="false" placeholder="Address code">
                  <ng-option *ngFor="let code of contactCodeData" [value]="code.codeValue">{{code.codeText}}</ng-option>
                </ng-select>
              </div>
            </div>
          </div> -->
          
        </div>
        
        
        <div class="block-title form-grouping-title pt-2">
          <h2>Payment Type
            <!-- <span style="color: #757575; text-transform: capitalize;">Pre-established direct debit account (EFT)</span> -->
          </h2>
          <div class="horizontal-line"></div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="add-user-detail">
              <input type="text" class="form-control" [value]="'Pre-established direct debit account (EFT)'" placeholder="Enter payment type" readonly>
            </div>
          </div>
          <!-- <div class="col-6">
            <div class="add-user-detail">
              <label for="">Payment type</label>
              <div class="input-block">
                <ng-select class="form-control w-100" [readonly]="true" formControlName="paymentType" tabindex="0" [items]="paymentCodeData" bindLabel="codeText" bindValue="codeValue" [searchable]="true" [clearable]="true" placeholder="Payment type">
                  <ng-option *ngFor="let code of paymentCodeData" [value]="code.codeValue">{{code.codeText}}</ng-option>
                </ng-select>
              </div>
            </div>
          </div>
          <div class="col-6  pd-l-0">
            <div class="add-user-detail">
              <label for="">
                Account id
                <span class="tooltip-icon pl-2">
                  <svg xmlns="http://www.w3.org/2000/svg" id="ic-info" width="20" height="20" viewBox="0 0 24 24">
                    <rect id="Rectangle_18062" data-name="Rectangle 18062" width="24" height="24" fill="none" />
                    <path id="info_FILL0_wght300_GRAD0_opsz24" d="M12,16.75a.725.725,0,0,0,.75-.75V11.725a.7.7,0,0,0-.212-.513.751.751,0,0,0-1.288.538v4.275a.7.7,0,0,0,.213.513A.728.728,0,0,0,12,16.75ZM12,9.3a.757.757,0,0,0,.575-.238.82.82,0,0,0,.225-.587.792.792,0,0,0-.225-.563.816.816,0,0,0-1.15,0,.792.792,0,0,0-.225.563.82.82,0,0,0,.225.587A.757.757,0,0,0,12,9.3Zm0,12.2a9.263,9.263,0,0,1-3.712-.75A9.432,9.432,0,0,1,3.25,15.712a9.563,9.563,0,0,1,0-7.425A9.435,9.435,0,0,1,8.288,3.25a9.563,9.563,0,0,1,7.425,0A9.437,9.437,0,0,1,20.75,8.287a9.563,9.563,0,0,1,0,7.425,9.435,9.435,0,0,1-5.037,5.038A9.27,9.27,0,0,1,12,21.5ZM12,12Zm0,8a7.714,7.714,0,0,0,5.663-2.337A7.714,7.714,0,0,0,20,12a7.714,7.714,0,0,0-2.337-5.663A7.714,7.714,0,0,0,12,4,7.711,7.711,0,0,0,6.338,6.337,7.713,7.713,0,0,0,4,12a7.713,7.713,0,0,0,2.338,5.663A7.711,7.711,0,0,0,12,20Z" fill="#0068D8" />
                  </svg>
                  <span class="text-tooltip info-list top">
                    We recommend leaving this value as 001 and is used by NIPR.
                  </span>
                </span>
              </label>
              <input type="text" class="form-control" [maxLength]="15" formControlName="accountId" placeholder="Account id" readonly>
            </div>
          </div> -->
        </div>
        <div>
          <validation-summary [validationErrors]="errorMessages"></validation-summary>
        </div>
      </div>
    </div>
    <div class="modal-footer pt-3 px-3 pb-2" *ngIf="isPopupView">
    <div class="action-btn-block justify-content-end mb-0">
        <button type="button" class="btn basic-btn btn-md" (click)="openConfirmationPopup()" [disabled]="appointerForm.pristine">
          Cancel
        </button>
        <button class="btn primary-btn btn-md" type="submit" [disabled]="!appointerForm.valid || appointerForm?.value?.complianceOfficer?.length <= 0">
          Add
        </button>
    </div>
    </div>
  </form>
